import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'

import AdvertiseCard from '@shared/components/advertiseWithUs/advertiseCard'
import IconPageView from '@assets/images/icon/page-views.svg'
import IconYouthAudience from '@assets/images/icon/youth-audience.svg'
import IconUsers from '@assets/images/icon/users.svg'
import IconTarget from '@assets/images/icon/target.svg'
import IconSocialReach from '@assets/images/icon/soical-reach.svg'
import AcrossPlatforms from '@shared/components/advertiseWithUs/acrossPlatforms'
import MyImage from '@shared/components/myImage'
import AdsLayout from '@assets/images/ads-layout.svg'
import BrandAds from '@assets/images/brandads.svg'
import ContentAds from '@assets/images/contentads.svg'
import VideoSolution from '@assets/images/video-solution.svg'
import AdvertisePartnersLeftToRight from '@shared/components/advertiseWithUs/advertisePartnerRight'
import AdvertisePartnersRightToLeft from '@shared/components/advertiseWithUs/advertisePartnerLeft'
import ContactUsAdvertise from '@shared/components/advertiseWithUs/contactUsAdvertise'
import FaqAdvertise from '@shared/components/advertiseWithUs/faq'
import Collaboration from '@shared/components/advertiseWithUs/collaboration'
import Layout from '@shared/components/layout'

function AdvertiseWithUs({ seoData, typeOfQuery }) {
  return (
    <Layout data={{ oSeo: seoData }}>
      <section className={`${styles.advertiseWithCricTracker}`}>
        <Container>
          <h1 className={`${styles.advertiseTitle} text-center fw-bold mb-md-4`}>Advertise with CricTracker & Reach Millions of Fans !</h1>
          <div className={`${styles.advertiseCardRow}`}>
            <AdvertiseCard src={IconPageView} title="2.4 Billion+" description="Page views" />
            <AdvertiseCard src={IconYouthAudience} title="96% " description="Youth Audience" />
            <AdvertiseCard src={IconUsers} title="1 Billion+" description="Users" />
            <AdvertiseCard src={IconTarget} title="67%" description="Traffic from india" />
            <AdvertiseCard src={IconSocialReach} title="550 Million+" description="Social Reach IPL 2023" />
          </div>
          <AcrossPlatforms />
        </Container>
      </section>

      <section className={`${styles.advertiseCricTracker} py-3`}>
        <Container>
          <Row className={`${styles.commonWidth} flex-column-reverse flex-md-row`}>
            <Col md={7} className="align-self-center">
              <div className={`${styles.advertisleft} text-md-start text-center`}>
                <h2 className={`${styles.advertiseTitleadd} mb-2 mb-md-3`}>Advertise with CricTracker</h2>
                <p className="big-text mb-0">
                  Maximize your brand’s reach with Standard Banner Ads and high-impact Interstitial Ads. Gain constant visibility with
                  Premium Fixed Ads, while Sticky Ads stay in view as users scroll.
                </p>
              </div>
            </Col>
            <Col md={5}>
              <MyImage src={AdsLayout} alt="adslayout" width="362" height="294" />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-4 py-md-1">
        <Container>
          <Row className={`${styles.commonWidth}`}>
            <Col md={5}>
              <MyImage src={BrandAds} alt="adslayout" width="472" height="330" />
            </Col>
            <Col md={7} className="align-self-center">
              <div className={`${styles.advertisright} text-md-end text-center`}>
                <h2 className={`${styles.advertiseTitleadd}`}>Brand Management Solutions</h2>
                <p className="big-text">
                  Enhance your brand’s presence with Social Media Handling, seamless Event Coverage, strategic Collaborations, and impactful
                  Sponsored Posts.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className={`${styles.adscontent}`}>
        <Container>
          <Row className={`${styles.commonWidth} flex-column-reverse flex-md-row`}>
            <Col md={7} className="align-self-center">
              <div className={`${styles.advertisleft} text-md-start text-center`}>
                <h2 className={`${styles.advertiseTitleadd}`}>Content Solutions</h2>
                <p className="big-text mb-0">
                  Engage your audience with News Feed Integration, Exclusive Content, RSS Feeds, and Fantasy Feed Integration for dynamic
                  updates.
                </p>
              </div>
            </Col>
            <Col md={5}>
              <MyImage src={ContentAds} alt="adslayout" width="387" height="204" />
            </Col>
          </Row>
        </Container>
      </section>

      <section className={`${styles.videoSolutionSection} py-1`}>
        <Container>
          <Row className={`${styles.commonWidth}`}>
            <Col md={5}>
              <MyImage src={VideoSolution} alt="adslayout" width="382" height="315" />
            </Col>
            <Col md={7} className="align-self-center">
              <div className={`${styles.advertisright} text-md-end text-center`}>
                <h2 className={`${styles.advertiseTitleadd}`}>Video Solutions</h2>
                <p className="big-text">
                  Enhance engagement with Live Shows, Reels & Shorts, Sponsored Videos, and Expert Analysis for impactful storytelling.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={`${styles.sportsBrands}`}>
        <Container>
          <h2 className={`${styles.sportsBrandsTitle} text-center`}>Successful Collaboration with Sports Brands</h2>
          <Collaboration />
        </Container>
      </section>

      <section className={`${styles.advertisePartners}`}>
        <h2 className={`${styles.advertisePartnersTitle} text-center`}>Our Advertise Partners</h2>
        <AdvertisePartnersLeftToRight />
        <AdvertisePartnersRightToLeft />
      </section>

      <section className="py-3 py-md-5" id="contact-us">
        <Container>
          <ContactUsAdvertise typeOfQuery={typeOfQuery} />
        </Container>
      </section>

      <section className={`${styles.FaqAdvertise} mb-4`}>
        <Container>
          <h2 className={`${styles.FaqAdvertiseTitle} text-center`}>Frequently Asked questions </h2>
          <FaqAdvertise />
        </Container>
      </section>
    </Layout>
  )
}
AdvertiseWithUs.propTypes = {
  seoData: PropTypes.object,
  typeOfQuery: PropTypes.array
}
export default AdvertiseWithUs

export async function getServerSideProps({ res, resolvedUrl, query }) {
  const { checkRedirectionStatus, handleApiError } = await import('@shared/utils')

  try {
    res.setHeader('Cache-Control', 'public, max-age=420')
    const url = resolvedUrl?.split('?')[0]

    const [graphql, articleQuery, contactQuery] = await Promise.all([
      import('@shared-components/queryGraphql'),
      import('@graphql/article/article.query'),
      import('@graphql/cms/cms.query')
    ])

    const [seoData, type] = await Promise.allSettled([
      graphql.default(articleQuery.GET_ARTICLE_ID, { input: { sSlug: url.replaceAll('/', '') || '' } }),
      graphql.default(contactQuery.GET_CONTACT_QUERY_TYPE)
    ])
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData, query?.amp)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    return {
      props: {
        seoData: seoData?.value?.data?.getSeoData || null,
        typeOfQuery: type?.value?.data?.getContactQueryType || null
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
